import { WORKFLOW_TYPES } from './constants';

export const isGenericLineItem = lineItem =>
  lineItem?.workflow_type === WORKFLOW_TYPES.GENERIC_MANUFACTURING;

export const getLineItemWorkflowTypeObjectKey = lineItem => {
  switch (lineItem?.workflow_type) {
    case WORKFLOW_TYPES.POWDER_MANUFACTURING:
      return 'powder';
    case WORKFLOW_TYPES.GENERIC_MANUFACTURING:
      return 'generic';
    default:
      return 'additive';
  }
};

export const getLineItemEstimatesTypeObjectKey = lineItem => {
  switch (lineItem?.workflow_type) {
    case WORKFLOW_TYPES.POWDER_MANUFACTURING:
      return 'estimates_powder';
    case WORKFLOW_TYPES.GENERIC_MANUFACTURING:
      return 'estimates_generic';
    default:
      return 'estimates_additive';
  }
};

/**
 * The model lives on the line item's own family object, and the other families come back as
 * null, so reading `additive` directly throws on a generic line item.
 */
export const getLineItemModel = lineItem =>
  lineItem?.[getLineItemWorkflowTypeObjectKey(lineItem)]?.model || null;

/** True when the line item was created without a model. */
export const getLineItemNoModelUpload = lineItem =>
  Boolean(lineItem?.[getLineItemWorkflowTypeObjectKey(lineItem)]?.no_model_upload);

/**
 * A generic line item carries a single workpiece material. Additive and powder carry a base
 * and support pair.
 */
export const getLineItemBaseMaterial = lineItem => {
  if (isGenericLineItem(lineItem)) {
    return lineItem?.generic?.material || null;
  }
  return lineItem?.[getLineItemWorkflowTypeObjectKey(lineItem)]?.materials?.base || null;
};
